<template>
  <StepItem
    format="form"
    :title="store.isGiveaway ? 'Start Your Business Draft Profile' : 'Let\'s get to know you'"
    :subtitle="store.isGiveaway ? 'This helps us show you relevant opportunities' : 'Personalize what opportunities you see'"
    :can-skip="true"
    @handle-next-step="handleNextStep"
    :is-ready-for-next-step="true"
  >
    <template v-slot:default>
      <FormLabel label="What is your minimum desired compensation?"/>
      <FormSliderPayAndHourlyVsSalary
        v-model:prefersHourlyOverSalary="store.prefersHourlyOverSalary"
        v-model:desiredHourlyPay="store.desiredHourlyPay"
        v-model:compensationFlexibility="store.compensationFlexibility"
        include-privacy-notice
        class="mt-6"/>
      <FormLabel
        v-if="!candidateStore.state.industries?.length"
        label="What industries are you interested in?"
        class="mt-16"
      />
      <FormTagBoxesSearch
        v-if="!candidateStore.state.industries?.length"
        :get-options="industries"
        v-model="store.industries"
        class="mt-4"
      />
    </template>
    <template v-slot:next-step-text>Finish Sign Up 🎉</template>
  </StepItem>
</template>

<script setup>
import StepItem from "./StepItem.vue";
import FormLabel from "./FormLabel.vue";
import FormTagBoxesSearch from "./FormTagBoxesSearch.vue";
import FormSliderPayAndHourlyVsSalary from "./FormSliderPayAndHourlyVsSalary.vue";
import {industries} from "../constants/Lists.js";
import {ref} from "vue";
import {useCandidateAccountCreateStore} from "../stores/CandidateAccountCreateStore";
import {useCandidateProfileStore} from "../stores/CandidateProfileStore.js";

const emits = defineEmits(["complete"]);

// Store logic
const store = useCandidateAccountCreateStore();
const candidateStore = useCandidateProfileStore();
const isReadyForNextStep = ref(false);

const handleNextStep = () => {
  validateCurrentStep(true);
  if (isReadyForNextStep.value) {
    try {
      store.updateCandidate(!candidateStore.state.industries?.length);
    } catch {
      toast.error("Something went wrong. Please try again later.");
      return;
    }
    emits("complete");
  }
};

const getIndustries = ref([]);

const setIndustries = async () => {
  getIndustries.value = await industries();
};

const validateCurrentStep = () => (isReadyForNextStep.value = store.validateStep5());

setIndustries();
</script>
